var path = '/templates/zenclerk_s/sites/stats/list.html';
var html = "";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_s_modules/zenclerk_s/sites/stats/list.html
// module id = 1440
// module chunks = 0